const initialState = {
    user: '',
    grades: [],
    sellingMarks: []
  }

  export default function rootReducer(state = initialState, action) {
    if (action.type == 'UPDATE_STATE') {
        console.log("Action : ", action);
        let obj  = {user: action.user, grades: action.grades, sellingMarks: action.sellingMarks};
        return { 
          obj
        }
    }

    return state;
  }
